// ******** Prestador Confirmação Agendamento *********
// app/PrestadorProfile/prestadorconfirmacacaoagendamento.jsx
// ******** autor: WdePaula / Microvolution
// ******** data: 08/11/24
// ***********************************




import React, { useState, useEffect } from 'react';
import apiaxios from '../../../../Services/apiaxios.js';
import Swal from 'sweetalert2';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Footer from '../../components/Footer/footer';
import { Spinner } from 'react-bootstrap';

import './prestadorconfirmacaoagendamento.css';

const PrestadorConfirmacaoAgendamento = () => {
    const { state } = useLocation();
    const [servicoNome, setServicoNome] = useState(state?.servicoNome || null);
    const [servicoData, setServicoData] = useState(state?.servicoData || null);
    const [servicoHorario, setServicoHorario] = useState(state?.servicoHorario || null);
    const [servicoValor, setServicoValor] = useState(state?.servicoValor || null);
    // const [profissionalNome, setProfissionalNome] = useState(state?.profissionalNome || null);
    const [empresaNome, setEmpresaNome] = useState(state?.empresaNome || null);
    const [empresaEndereco, setEmpresaEndereco] = useState(state?.empresaEndereco || null);
    const [empresaCelular, setEmpresaCelular] = useState(state?.empresaCelular || null);
    const [fotoPerfil, setFotoPerfil] = useState(state?.fotoPerfil || null);
    const [clienteNome, setClienteNome] = useState(state?.nomeCliente || null);
    const [clienteFone, setClienteFone] = useState(state?.celularCliente || null);
    const [idResreva, setIdReserva] = useState(state?.resId || null);
    const [id_usuario, setId_usuario] = useState(state?.id || null);
    const [id_usuario_anonimo, setId_usuario_anonimo] = useState(state?.idUsuarioAnonimo || null);
    const [loading, setLoading] = useState(false);    // console.log('clienteNome ', clienteNome);
    // console.log('clienteFone ', clienteFone);
    // console.log('idResreva ', idResreva);
    // console.log('confirmação agendamento - state :', state);
    // console.log('confirmação agendamento - servicoData :', servicoData);
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkpersonalizado, id, profId, servId, reservaId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Rola a página para o topo ao montar o componente
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        
        handleEnviarAgendamentoViaWhats();

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    const handleEnviarAgendamentoViaWhats = () => {
        window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessageEnviarAgendamento}`, '_blank');
    };

    // Número do WhatsApp do estabelecimento
    // const whatsappNumber = encodeURIComponent(`${empresaCelular}`);
    // const whatsappNumber = encodeURIComponent(empresaCelular.replace(/\D/g, '')); // Remove caracteres não numéricos
    // Número do WhatsApp do estabelecimento com código do país Brasil (55)
    const whatsappNumber = `55${empresaCelular.replace(/\D/g, '')}`;
    // console.log(whatsappNumber);

    // Construir a mensagem personalizada para WhatsApp
    const whatsappMessageEnviarAgendamento = encodeURIComponent(
`****************************
    MEU AGENDAMENTO
    CLIENTE: ${clienteNome || "Nome cliente não informado"}
    TELEFONE: ${clienteFone || "Telefone do cliente não informado"}
    ****************************
    SERVIÇO/ID: ${servicoNome || "Serviço não informado"} - ${idResreva || "Id não informado"}
    VALOR: ${servicoValor || "Valor não informado"}
    DATA: ${servicoData || "Data não informada"}
    HORÁRIO: ${servicoHorario || "Horário não informado"}
    ****************************
    COMPROVANTE DE AGENDAMENTO
****************************`
    );

    const handleNovoAgendamento = () => {
        navigate(`/agendar/${linkpersonalizado}`);
    };

    const handleAlterarAgendamento = () => {
        // Lógica para alterar o agendamento
        // Pode ser uma navegação para a página de agendamento ou exibição de um modal
        // Swal.fire('Atenção', 'Função de "alteração" não disponível nesta versão. Baixe o app Agendex Cliente na Google Play', 'info');
        Swal.fire('Atenção', 'Função de "alteração" não disponível nesta versão. Utilize o botão "Cancelar Agendamento".', 'info');
    };

    const handleCancelarAgendamento = () => {
        // Lógica para cancelar o agendamento
        // Pode ser uma navegação para a página de cancelamento ou exibição de um modal
        // Swal.fire('Atenção', 'Função de "cancelamento" não disponível nesta versão. Baixe o app Agendex Cliente na Google Play', 'info');
        // console.log ('dentro do handleexcluir no início array "agendamento:" ', agendamento, agendamento.agendamento_id);
        // console.log ('dentro do handleexcluir no início array "agendamento:" ', idResreva, servicoData);
        // const ID_RESERVA = idResreva;
        // const DATA_RESERVA_STRING = servicoData;
        // console.log("Valor de DATA_RESERVA_STRING:", DATA_RESERVA_STRING); // Adicione esta linha

        // if (!DATA_RESERVA_STRING) { // Verificação adicional
        //     console.error("DATA_RESERVA_STRING está indefinido ou vazio. Cancelando a função.");
        //     return;
        // }
        const dataString = servicoData;
        const horarioString = servicoHorario;

        if (!dataString || typeof dataString !== 'string' || dataString.trim() === '') {
            console.error("servicoData inválida:", dataString);
            Swal.fire('Erro', 'Data do agendamento inválida.', 'error');
            return;
        }

        if (!horarioString || typeof horarioString !== 'string' || horarioString.trim() === '') {
            console.error("servicoHorario inválido:", horarioString);
            Swal.fire('Erro', 'Horário do agendamento inválido.', 'error');
            return;
        }

        const [day, month, year] = dataString.split('/');
        if (!day || !month || !year) {
            console.error("Formato de data incorreto:", dataString);
            Swal.fire('Erro', 'Formato de data incorreto.', 'error');
            return;
        }

        const [hours, minutes] = horarioString.split(':');
        if (!hours || !minutes) {
            console.error("Formato de hora incorreto:", horarioString);
            Swal.fire('Erro', 'Formato de hora incorreto.', 'error');
            return;
        }

        try {
            const DATA_RESERVA = new Date(year, month - 1, day, hours, minutes);

            if (isNaN(DATA_RESERVA)) {
                console.error("Data resultante inválida:", DATA_RESERVA);
                Swal.fire('Erro', 'Data e/ou hora inválidas.', 'error');
                return;
            }

            // Resto do seu código para comparação de datas e envio da requisição...
        } catch (error) {
            console.error("Erro ao criar objeto Date:", error);
            Swal.fire('Erro', 'Erro ao processar data e/ou hora do agendamento.', 'error');
            return;
        }
    
        // const [datePart, timePart] = DATA_RESERVA_STRING.split(' ');
        // const [day, month, year] = datePart.split('/');
        // const [hours, minutes, seconds] = timePart.split(':');
        // const DATA_RESERVA = new Date(year, month - 1, day, hours, minutes, seconds);

        const dataAtual = new Date();

        // if (!dataAtual) {
        //     console.error('Erro: dataAtual está indefinido');
        //     return;
        // }

        // if (DATA_RESERVA < dataAtual) {
        //     Swal.fire('Atenção', 
        //                 'Prazo para exclusão vencido. Agendamento em análise!', 
        //                 'warning');
        //         return;
        // } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
        //     dataAtual.getHours() >= DATA_RESERVA.getHours() - 2) {
        //     Swal.fire('Atenção', 
        //                 'Prazo para exclusão vencido. Não falte ao compromisso com o prestador de serviços!',
        //                 'warning');
        //         return;
        // } else if (DATA_RESERVA.toDateString() === dataAtual.toDateString() && 
        //     dataAtual.getHours() >= DATA_RESERVA.getHours() && 
        //     dataAtual.getHours() < DATA_RESERVA.getHours() + 3) {
        //     Swal.fire('Atenção', 
        //                 'Prazo para exclusão vencido. Você já deve estar dentro do atendimento!', 
        //                 'warning');
        //         return;
        // }

        Swal.fire({
            title: 'Excluir Agendamento',
            html: `
                <label for="motivo">Motivo do Cancelamento:</label>
                <textarea id="motivo" class="swal2-textarea" placeholder="Digite o motivo" minlength="10"></textarea>
                <p>ID_RESERVA: ${idResreva}</p>
                <p>Data/Hora exclusão: ${dataAtual.toLocaleString()}</p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const motivo = Swal.getPopup().querySelector('#motivo').value;
                if (!motivo || motivo.length < 10) {
                    Swal.showValidationMessage('Para cancelar seu agendamento, você precisa primeiro dizer o motivo (mínimo 10 caracteres)');
                    return false;
                }
                return motivo;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const motivo = result.value;
                // const id_usuario = JSON.parse(localStorage.getItem("tokenapw")).id_usuario;
                setLoading(true)

                apiaxios.put('reserva/ReservaExcluirPrestadorWeb', {
                    id_reserva: idResreva,
                    tipo_exclusao: 'C',
                    id_usuario,
                    id_usuario_anonimo,
                    obs_cancel: motivo
                })
                .then(response => {
                    if (response.status === 200 && response.data.retorno === "OK") {
                        Swal.fire('Excluído!', 'Seu agendamento foi excluído com sucesso.', 'success');
                    } else {
                        Swal.fire('Erro', response.data.retorno || 'Erro ao excluir agendamento', 'error');
                    }
                })
                .catch(error => {
                    Swal.fire('Erro', 'Erro ao excluir agendamento: ' + error, 'error');
                }).finally (
                    setLoading(false)
                );
            }
        });        
    };



    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col py-3 me-3 text-center">
                    <img src={isMobile ? imgLogoMini : imgLogomarca} className={`img-logo ${isMobile ? 'img-logo-mobile' : 'img-logo-desktop'}`} alt="logo agendex"/>
                    <br/>
                    <h2>Agendamento Realizado!</h2>
                    <button className='btn btn-primary btn-lg'onClick={handleNovoAgendamento} data-toggle="tooltip" data-placement="button" title="clique aqui se deseja marcar um novo agendamento nesta empresa"><i className="bi bi-calendar-plus-fill"></i> Iniciar Novo Agendamento</button>
                    <div className="agendamento-info">
                        <p><strong>Data: {servicoData}</strong> {/* Inserir a data do agendamento */}</p>
                        <p><strong>Horário: {servicoHorario} hs</strong> {/* Inserir o horário do agendamento */}</p>
                        <p><strong>Serviço/id: {servicoNome} / {idResreva}</strong> {/* Inserir o nome do serviço */}</p>
                        <p><strong>Valor: {servicoValor}</strong> {/* Inserir o valor do serviço */}</p>
                        <p><strong>Estabelecimento: {empresaNome}</strong> {/* Inserir o nome da empresa */}</p>
                        <p><strong>Endereço: {empresaEndereco}</strong> {/* Inserir o nome da empresa */}</p>
                        <br />
                        <button className='btn btn-warning p-10' disabled onClick={handleAlterarAgendamento} data-toggle="tooltip" data-placement="top" title="função indisponível nesta versão">
                            Alterar Agendamento
                        </button>
                        <button className='btn btn-danger ml-10 mt-10' onClick={handleCancelarAgendamento} data-toggle="tooltip" data-placement="top" title="Clique para cancelar este agendamento">
                            Cancelar Agendamento
                        </button>
                    </div>
                </div>
            </div>
            {fotoPerfil ? 
                (
                    <div className='text-center'>
                        <img src={fotoPerfil} alt={empresaNome} className='usuario-foto'/>
                    </div>
                ) : (
                    <p className='text-center'>{empresaNome}</p>
            )}
            <Footer/>
        </div>
    );
};

export default PrestadorConfirmacaoAgendamento;